import useSWR from 'swr';
import { Tab } from './index';
import { customFetcher } from '../../../utils';
import { Device, DeviceWithWorkTime } from '../../../globals/interfaces';
import VirtualTable from '../../../components/custom/VirtualTable';
import moment from 'moment';
import { useState } from 'react';
import { Label, Input } from 'reactstrap';
import styled from 'styled-components';

export default function Logs({
    tabId,
    unit
}: {
    tabId: Tab;
    unit: string;
}) {

    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const key = tabId === 'LOGS' ? 
        `/device/logs?unit=${unit}&date=${date}` : 
        null;

    const {
        data
    } = useSWR(key, customFetcher<DeviceWithWorkTime>, {
        fallbackData: []
    });

    return (
        <div>
            <FlexContainer>
                <Label>
                    Date
                </Label>
                <CustomInput 
                    type={'date'} 
                    value={date} 
                    onChange={(e) => setDate(e.target.value)}
                />
            </FlexContainer>
            <VirtualTable<DeviceWithWorkTime>
                data={data}
                mapping={[{
                    name: 'User',
                    value: 'email',
                    email: true
                }, {
                    name: 'First Name',
                    value: 's_first_name'
                }, {
                    name: 'Last Name',
                    value: 's_last_name'
                }, {
                    name: 'Device',
                    value: 'internalName',
                    largeWidth: true
                }, {
                    name: 'Device ID',
                    value: 'deviceId'
                }, {
                    name: 'EOS ID',
                    value: 'deviceName',
                    largeWidth: true
                }, {
                    name: 'Login',
                    value: 'startTime',
                    utc: true,
                    datetime: true
                }, {
                    name: 'Logout',
                    value: 'endTime',
                    utc: true,
                    datetime: true
                }, {
                    name: 'Duration (Hours:minutes)',
                    value: 'duration',
                    number: true
                }]}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    align-items: baseline;
    gap: 10px;
`;

const CustomInput = styled(Input)`
    width: 200px;
`;